import { combineReducers } from "@reduxjs/toolkit";

import { audioPlayerReducer } from "domains/audioPlayer/reducer";
import { authenticationReducer } from "domains/authentication/reducers";
import { bookmarksReducer } from "domains/bookmarks/reducer";
import { caseStudiesReducer } from "domains/caseStudy/reducer";
import { clustersReducer } from "domains/clusters/reducers";
import { coachmarksReducer } from "domains/coachmarks/reducer";
import { collectionsReducer } from "domains/collection/reducer";
import { createMapReducer } from "domains/createMapDetail/reducers";
import { shareMapReducer } from "domains/createShareSettings/reducer";
import { customContentAndSourcesReducer } from "domains/customContentAndSources/reducers";
import { customKeyIssueReducer } from "domains/customKeyIssue/reducers";
import { eventsReducer } from "domains/events/reducer";
import { filteredTopicsReducer } from "domains/filteredTopicList/reducer";
import { incidentsReducer } from "domains/incidents/reducer";
import { initiativesReducer } from "domains/initiatives/reducer";
import { knowledgeDataReducer } from "domains/knowledgeData/reducer";
import { knowledgeFeedReducer } from "domains/knowledgeFeed/reducer";
import { languageReducer } from "domains/language/reducer";
import { membershipEventsReducer } from "domains/membershipEvents/reducer";
import { modalReducer } from "domains/modal/reducer";
import { emergingThemesReducer } from "domains/monitor/emergingThemes/reducer";
import { filtersReducer } from "domains/monitor/filter/reducer";
import { latestKnowledgeReducer } from "domains/monitor/latestKnowledge/reducer";
import { suggestedTopicsReducer } from "domains/monitor/suggestions/reducer";
import { notificationsReducer } from "domains/notifications/reducer";
import { pinAddRejectReducer } from "domains/pinAddReject/reducers";
import { publicationReducer } from "domains/publication/reducer";
import { searchReducer } from "domains/search/reducer";
import { stakeholdersReducer } from "domains/stakeholders/reducer";
import { themeReducer } from "domains/theme/reducer";
import { topicReducer } from "domains/topic/reducer";
import { topicContentMetaReducer } from "domains/topicSearchFilter/reducers";
import { transformationMapReducer } from "domains/transformationMap/reducers";
import { videosReducer } from "domains/videos/reducer";
import { visualMediaPlayerReducer } from "domains/visualMediaPlayer/reducer";
import { whatsNewReducer } from "domains/whatsNew/reducer";

export const domainsReducer = combineReducers({
  audioPlayer: audioPlayerReducer,
  authentication: authenticationReducer,
  bookmarks: bookmarksReducer,
  caseStudies: caseStudiesReducer,
  clusters: clustersReducer,
  coachmarks: coachmarksReducer,
  collections: collectionsReducer,
  createMap: createMapReducer,
  customContentAndSources: customContentAndSourcesReducer,
  customKeyIssue: customKeyIssueReducer,
  emergingThemes: emergingThemesReducer,
  events: eventsReducer,
  filteredTopics: filteredTopicsReducer,
  filters: filtersReducer,
  incidents: incidentsReducer,
  initiatives: initiativesReducer,
  knowledgeData: knowledgeDataReducer,
  knowledgeFeed: knowledgeFeedReducer,
  language: languageReducer,
  latestKnowledge: latestKnowledgeReducer,
  membershipEvents: membershipEventsReducer,
  modal: modalReducer,
  notifications: notificationsReducer,
  pinAddReject: pinAddRejectReducer,
  publication: publicationReducer,
  search: searchReducer,
  shareMap: shareMapReducer,
  stakeholders: stakeholdersReducer,
  suggestedTopics: suggestedTopicsReducer,
  theme: themeReducer,
  topic: topicReducer,
  topicContentMeta: topicContentMetaReducer,
  transformationMap: transformationMapReducer,
  videos: videosReducer,
  visualMediaPlayer: visualMediaPlayerReducer,
  whatsNew: whatsNewReducer,
});
